/** VSplitContainer registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseVSplitContainer } from './parser';
const vSplitContainerRegistration = {
    typeName: 'VSplitContainer',
    parser: parseVSplitContainer,
};
nodeRegistry.register(vSplitContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map